import React, {PropTypes} from 'react';
import classNames from 'classnames';
import Link from 'shared/Link.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const NavigationBar = ({
  actions
}) => (
  <div className="btn-group navigation-bar">
    {actions.map((action, index) => (
      <Link
        key={index}
        to={action.to}
        className={classNames(
          "btn",
          {"btn-default": !action.active},
          {"btn-primary": action.active},
          {"nav-origin": action.navOrigin}
        )}
      >
      {action.navOrigin
        ? <i className="fa fa-home" />
        : action.label
      }
      <DisplayIf condition={!!action.iconClassName}
        style={{display: 'inline'}}>
        {' '}<i className={`fa ${action.iconClassName} ${action.iconColorClassName || ''}`} />
      </DisplayIf>
      </Link>
    ))}
  </div>
);

NavigationBar.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object)
};

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/features/shared/navigationBar/NavigationBar.jsx